import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {propTypes, defaultProps} from 'react-props-decorators';
import AbstractMapMarker from "components/ui/map/base/marker";
import StopPointIcon from "components/ui/map/markers/icons/stop-point-icon";
import _ from 'lodash';
import ReactPopup from "react-leaflet-popup";
import L from 'leaflet';
import './stop-point-marker.less'


@propTypes({
    item: PropTypes.object,
    color: PropTypes.oneOf([null, 'red', 'green']),
    permanentTooltip: PropTypes.bool,
    withoutPopup: PropTypes.bool,
    onEditClick: PropTypes.func,
})

@defaultProps({
    color: null,
    permanentTooltip: false,
    withoutPopup: false,
    onEditClick: null,
})

export default class StopPointMarker extends AbstractMapMarker {

    getOptions() {
        return {
            icon: StopPointIcon.getIcon(this.props.color),
            riseOnHover: true,
            zIndexOffset: this.props.zIndex,
        };
    }

    componentWillMount() {
        super.componentWillMount();

        if ((this.props.onClick === null) && !this.props.withoutPopup) {
            this.getMarker().on('click', ::this.loadPopup)
        }
    }

    componentDidMount() {
        super.componentDidMount();

        this.forceUpdate();
    }

    componentWillUpdate(props) {
        const oldItem = this.props.item;
        const newItem = props.item;

        this.checkTitleUpdate(oldItem, newItem, props);
    }

    checkTitleUpdate(oldItem, newItem, props) {
        const marker = this.getMarker();
        const oldTitle = _.get(oldItem, 'title');
        const newTitle = _.get(newItem, 'title');
        const oldPermanentToolTip = this.props.permanentTooltip;
        const newPermanentToolTip = props.permanentTooltip;
        if (((oldPermanentToolTip !== newPermanentToolTip) || (oldTitle !== newTitle) || !marker.getTooltip()) && newTitle) {
            marker.unbindTooltip().bindTooltip(newTitle, {
                sticky: true,
                permanent: newPermanentToolTip,
            });
        }
    }

    loadPopup() {
        if (!this.props.item) {
            return;
        }

        const marker = this.getMarker();
        marker.unbindPopup();
        marker.closePopup();
        marker.bindPopup(
            this.createStopPointPopup(::marker.closePopup)
        );
        marker.openPopup();
    }

    createStopPointPopup(onClose) {
        const stopPoint = this.props.item;
        if (!stopPoint) {
            return null;
        }

        return new ReactPopup({
            reactComponent: StopPointPopup,
            reactComponentProps: {
                ...this.props,
                stopPoint,
                onClose,
            },
            minWidth: 434,
            maxWidth: 434,
            offset: new L.Point(3, -250),
        });
    }
}

class StopPointPopup extends Component {

    render() {
        const {stopPoint, onScheduleClick, onFromHereClick, onToHereClick} = this.props;

        return (
            <div className="b-modal b-modal-map map-tooltip-modal tooltip-stop b-modal_stop-point">
                <div className="b-modal__header">
                    <a href="#" className="b-modal__close" onClick={::this.onClose}/>
                    <div className="b-modal__name align-middle">{stopPoint.title}</div>
                </div>
                <div className="b-modal__body">
                    <div className="b-block">
                        <div className="b-block__desc">Координаты</div>
                        <div className="b-block__value">{_.round(stopPoint.latitude, 6)}, {_.round(stopPoint.longitude, 6)}</div>
                    </div>
                    {stopPoint.location ? (
                        <div className="b-block">
                            <div className="b-block__desc">Место нахождения</div>
                            <div className="b-block__value">{stopPoint.location}</div>
                        </div>
                    ) : null}
                </div>
                <div className="b-modal__footer">
                    {!window.RNIS_SETTINGS.get_away_button_hide ? (
                        <a href="javascript:void(0)" className="b-button b-button_size_md b-button_red b-button_card"
                           onClick={::this.onFromHereClick}>Уехать отсюда</a>
                    ) : null }
                    {!window.RNIS_SETTINGS.get_away_button_hide ? (
                        <a href="javascript:void(0)" className="b-button b-button_size_md b-button_red b-button_card"
                           onClick={::this.onToHereClick}>Уехать сюда</a>
                    ) : null }
                    <a href="javascript:void(0)" className="b-button b-button_size_md b-button_red b-button_card"
                       onClick={::this.onScheduleClick}>Расписание</a>
                </div>
            </div>
        );
    }

    onFromHereClick() {
        this.props.onFromHereClick();
        this.props.onClose();
    }

    onToHereClick() {
        this.props.onToHereClick();
        this.props.onClose();
    }

    onScheduleClick() {
        this.props.onScheduleClick();
        this.props.onClose();
    }

    onClose(e) {
        e.preventDefault();
        this.props.onClose();
    }
}



// WEBPACK FOOTER //
// ./src/components/ui/map/markers/stop-point-marker.js